import React, { FC } from "react";

import { Link, LinkProps, useTheme } from "@mui/material";

import { IgTypography } from "./IgTypography";
import { IgCustomTheme } from "./theme";

interface IgTypographyProps extends LinkProps {
  disabled?: boolean;
}

/**
 * @see Link
 * @see IgTypography
 */
export const IgLink: FC<IgTypographyProps> = (props) => {
  const { children, sx, disabled, variant, ...rest } = props;
  const theme = useTheme();
  if (disabled) {
    return (
      <IgTypography
        variant={variant ?? "body1"}
        sx={{
          color: (theme as IgCustomTheme).palette.text.interactive.accent
            .disabled,
          ...sx,
        }}
        onClick={undefined}
        {...rest}
      >
        {children}
      </IgTypography>
    );
  }
  return (
    <Link
      variant={variant ?? "body1"}
      {...rest}
      underline={"hover"}
      sx={{
        "&:hover, &:focus": {
          cursor: "pointer",
          color: `${(theme as IgCustomTheme).palette.text.interactive.accent.hover} !important`,
        },
        color: `${(theme as IgCustomTheme).palette.text.accent} !important`,
        ...sx,
      }}
    >
      {children}
    </Link>
  );
};
